interface Selectors {
	dataList: string;
	dataItem: string;
	header: string;
	value: string;
}

export interface CSVConfig {
	headers: string[];
	selectors: Selectors;
	filename: string;
}

export interface CSVHeaderConfig {
	selector: string;
	label: string;
}

export const getCSVHeaders = (config: CSVHeaderConfig) => {
	return Array.from(document.querySelectorAll(config.selector))
		.reduce((headers: string[], item: Element): string[] => {
			const header: string | null = item.getAttribute(config.label);
			if (header) {
				if (headers.indexOf(header) === -1) {
					headers.push(header);
				}
			}
			return headers;
		}, []);
};

export const exportCSV = ({ headers, selectors, filename }: CSVConfig) => {
	const csv: string[] = Array.from(document.querySelectorAll(selectors.dataList))
		.map((opp: Element) => {
			const data: string[] = [];
			const rows: Element[] = Array.from(opp.querySelectorAll(selectors.dataItem));
			rows.forEach((col: Element) => {
				const header: string | null = col.getAttribute(selectors.header);
				const value: string | null = col.getAttribute(selectors.value);
				if (header) {
					const headerIndex: number = headers.indexOf(header);
					if (headerIndex !== -1) {
						data.splice(headerIndex, 1, value ? `"${value}"` : '');
					}
				}
			});
			return data.join(',');
		});

	csv.unshift(headers.join(','));
	const csvString: string = csv.join('\n');

	const a: HTMLElement = document.createElement('a');
	a.setAttribute('style', 'display: none');
	document.body.appendChild(a);

	const blob: Blob = new Blob([csvString], { type: 'text/csv' });
	const url: string = window.URL.createObjectURL(blob);
	a.setAttribute('href', url);
	a.setAttribute('download', filename);
	a.click();
	window.URL.revokeObjectURL(url);
	a.remove();
};
